import { Component, OnInit } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { Router, ActivatedRoute } from '@angular/router';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { TRANSLATION_ANCILLARY_DETAILED, ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN, TRANSLATION_ANCILLARY_GROUP, ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST, BRAND_NAMES_MAP } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';

@Component({
  selector: 'app-details-priority-check-in',
  templateUrl: './details-priority-check-in.indra.component.html',
  styleUrls: ['./details-priority-check-in.component.scss']
})
export class INDRADetailsPriorityCheckInComponent  implements OnInit {

	flight;
	flightRouteInput: any;

	flightIdentifier: string;
	departureLocation: string;

	passengers: INDRAPax[] = [];
	paxFareInfoFeatures = [];
	paxPurchaseFeatures = [];

	LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.'
	LOCAL_TRANSLATION_DETAILED_PRIORITY_CHECKIN = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsPriorityCheckin.'
	ancillaryGroup: string;
	
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brandDescription: string;
	
	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		private ibeAdminService: INDRAIbeAdminService,
		public ancillaryCartService: INDRAAncillariesShoppingCartService,
		private bookingSearchService: INDRABookingSearchService
	) { 
		if (this.router.url.includes('/my-bookings/view/')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
	}


	ngOnInit() {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.flightRouteInput = this.bookingService.INDRA_getFlightRoute(this.flight);
		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.ancillaryGroup = ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN;
		this.brandDescription = this.INDRA_getBrandDescription();

		this.departureLocation = this.INDRA_fetchDepartureLocation();

		let fareInfoAncillary = this.bookingService.INDRA_getPassengersAncillaryFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN, this.flight.idFlight.toString());
		let purchasedAncillary = this.bookingService.INDRA_getPassengersPurchasedAncillary(ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN, this.flight.idFlight.toString(), this.flightIdentifier);

		this.passengers.forEach(pax => {
			const fareInfoindex = fareInfoAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxfareAncillaries = fareInfoAncillary[fareInfoindex];
			this.paxFareInfoFeatures.push({
				[pax.idPax] : this.INDRA_constructAncillaryList(paxfareAncillaries[pax.idPax])
			});
			;

			const purchasedIndex = purchasedAncillary.findIndex(
				object => object[pax.idPax]
			);
			let paxpurchasedAncillaries = purchasedAncillary[purchasedIndex];
			this.paxPurchaseFeatures.push({
				[pax.idPax] : this.INDRA_constructAncillaryList(paxpurchasedAncillaries[pax.idPax])
			});
			//sort ascending based on segmentID
			this.paxPurchaseFeatures.sort((first, second) =>  (Number(first.segmentId) > Number(second.segmentId) ? -1 : 1));
			;
		});
	}

	INDRA_checkUnconfirmed(pax: INDRAPax) {
		let returnValue = false;
		let purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN, this.flight.idFlight.toString(), this.flightIdentifier);
		const purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(
			object => object[pax.idPax]
		);
		let paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
		paxpurchasedAncillaries[pax.idPax].forEach((segment) => {
			segment.ancillaryList.forEach((ancillary) => {
				if (ancillary.unconfirmed) {
					returnValue = true;
				}
			});
		});
		return returnValue;
	}

	INDRA_constructAncillaryList(list: string[]) {
		let returnValue = '';
		list.forEach(item => {
			if (returnValue.length === 0) {
				returnValue = "1 " + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + item}`);
			} else {
				returnValue = returnValue + ', ' + "1 " + this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_DETAILED + item}`);
			}
		});

		return returnValue;
	}
	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_printBrand() {
		return this.brandDescription;
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' +  this.INDRA_capitalize(pax.surname);
	}

	INDRA_getAncillaryForPassenger(list: any, idPax: number) {
		let returnValue;
		const index = list.findIndex(
			item => Object.keys(item)[0] === idPax.toString()
		);
		if (list) {
			let paxAncillary = list[index];
			returnValue = paxAncillary[idPax];
			return returnValue;
		}

	}

	INDRA_printDepartureLocation() {
		return this.departureLocation;
	}

	INDRA_fetchDepartureLocation() {
		const departureLocationObj = this.bookingService.INDRA_DepartureLocationOfFlight(this.flightIdentifier.toString());
		if (departureLocationObj) {
			return departureLocationObj.name;
		}

		return '';
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }

	openMusicalSidebar() {
		this.sidebarService.openSidebar(['ancillaries--music-instruments', { flight: this.flightIdentifier }]);
	}

	INDRA_getGroupLabel() {
		let groupList: string[] = ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST;
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARY_GROUP + groupList[0]}`);
	}

	INDRA_getTitleTranslation(lastKey: string, keyType: string) {
		const key = this.LOCAL_TRANSLATION_DETAILED_PRIORITY_CHECKIN + keyType + "." + lastKey;
		return this.INDRA_getTranslation(key);
	}

	INDRA_getTranslationKey(lastKey: string, keyType: string) {
		return this.LOCAL_TRANSLATION_DETAILED_PRIORITY_CHECKIN + keyType + "." + lastKey;
	}
	
	INDRA_printImage() {
		const IMAGE = 'check-in_priority.jpg';
		return 'url(assets/images/ancillaries/includes/' + IMAGE + ')';
	}
	
	INDRA_getBrandDescription() {
		if (this.isBookingView || this.isReviewTTTCompletion) {
			if (!this.flight.fareFamily) return '';
			const brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
			return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
		} else {
			this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
		}
	}
}
